<template>
  <view-page
      baseRoute="company.distribution-list"
      entity="Distribution List"
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :model-id="$route.params.distributionListId"
  >
    <template v-slot="{model}">
      <distribution-list-form
          :readonly="readonly"
          v-model="model"
          ref="form"
          :loading="loading"
      />
    </template>
  </view-page>
</template>

<script>

import DistributionListForm from '@/views/pages/companies/DistributionList/DistributionListForm';
import ViewPage from "@/views/components/Views/ViewPage";

export default {
  name: "DistributionListView",
  components: {
    DistributionListForm,
    ViewPage,
  },
  data() {
    return {
      readonly: true,
      loading: false,
      modelEntity: this.$api.companies.distributionLists,
      entity: 'Distribution List',
      componentAccess: {
        canEdit: {
          route: 'company.distribution-list.edit',
          access: false,
        },
        canDelete: {
          route: 'company.distribution-list.delete',
          access: false,
        },
      }
    };
  },
};
</script>
